module.exports = __webpack_public_path__ + "img/dialog_touch.182c25b8.svg";